var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDispatch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 22.4,
    viewBox: "0 0 21 22.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18077",
    "data-name": "Grupo 18077",
    transform: "translate(-0.5 -1.078)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18076",
    "data-name": "Grupo 18076",
    transform: "translate(-206.48 -299.977)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "box-seam_2_",
    "data-name": "box-seam (2)",
    d: "M4.464.642a.273.273,0,0,0-.2,0l-3.255,1.3,1.311.524L5.674,1.126,4.464.642Zm1.944.778L3.052,2.762l1.311.524L7.719,1.944Zm1.772.927L4.635,3.764v4.32L8.18,6.667V2.347ZM4.09,8.085V3.764L.545,2.347V6.667ZM4.059.135a.818.818,0,0,1,.608,0L8.554,1.691a.273.273,0,0,1,.171.253V6.667a.545.545,0,0,1-.343.506L4.464,8.741a.273.273,0,0,1-.2,0L.344,7.173A.545.545,0,0,1,0,6.667V1.944a.273.273,0,0,1,.171-.253Z",
    transform: "translate(214.488 307.979)",
    fill: "#003082",
    stroke: "#003082",
    strokeWidth: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "journal-check",
    transform: "translate(0.5 1.078)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_282",
    "data-name": "Trazado 282",
    d: "M3.8,0h14a2.8,2.8,0,0,1,2.8,2.8V19.6a2.8,2.8,0,0,1-2.8,2.8H3.8A2.8,2.8,0,0,1,1,19.6V18.2H2.4v1.4A1.4,1.4,0,0,0,3.8,21h14a1.4,1.4,0,0,0,1.4-1.4V2.8a1.4,1.4,0,0,0-1.4-1.4H3.8A1.4,1.4,0,0,0,2.4,2.8V4.2H1V2.8A2.8,2.8,0,0,1,3.8,0Z",
    transform: "translate(0.4)",
    fill: "#003082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_283",
    "data-name": "Trazado 283",
    d: "M1.4,5.4V4.7a.7.7,0,0,1,1.4,0v.7h.7a.7.7,0,0,1,0,1.4H.7a.7.7,0,1,1,0-1.4Zm0,8.4v-.7a.7.7,0,1,1,1.4,0v.7h.7a.7.7,0,0,1,0,1.4H.7a.7.7,0,1,1,0-1.4Z",
    transform: "translate(0 1.6)",
    fill: "#003082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2306",
    "data-name": "Trazado 2306",
    d: "M1.371,19.728v-.685a.685.685,0,1,1,1.371,0v.685h.685a.685.685,0,0,1,0,1.371H.685a.685.685,0,0,1,0-1.371Z",
    transform: "translate(0.044 -8.528)",
    fill: "#003082"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDispatch);
export default __webpack_public_path__ + "static/media/dispatch.158b2e3a78fb6d3344377d00746077a3.svg";
export { ForwardRef as ReactComponent };